import { Injectable } from '@angular/core';
import { BehaviorSubject, } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';
import { authConfig } from './auth.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  userData: any = null;

  constructor(private oidcSecurityService: OidcSecurityService) {
    this.oidcSecurityService.isAuthenticated$.subscribe(({isAuthenticated}) => {
      this.isAuthenticatedSubject.next(isAuthenticated);
    });

    this.oidcSecurityService.userData$.subscribe((userData) => {
      this.userData = userData;
    });
  }

  login(): void {
    this.oidcSecurityService.authorize();
  }

  logout(): void {
    localStorage.clear();
    window.location.href = `${environment.cognitoDomain}/logout?client_id=${environment.cognitoClientId}&logout_uri=${Array.isArray(authConfig?.config) ? authConfig?.config?.[0].postLogoutRedirectUri : authConfig?.config?.postLogoutRedirectUri}`;
  }
}
